import React from "react";

// Mickey ears silhouette (head + two ears) as SVG
export const MickeyEars = ({ className = "", color = "#111", size = 64 }) => (
    <svg
        viewBox="0 0 100 90"
        width={size}
        height={(size * 90) / 100}
        className={className}
        aria-hidden="true"
    >
        <circle cx="22" cy="22" r="18" fill={color} />
        <circle cx="78" cy="22" r="18" fill={color} />
        <circle cx="50" cy="58" r="28" fill={color} />
    </svg>
);

export default MickeyEars;
